import React from "react";
import PropTypes from "kf-proptypes/widgets";

import {
  DimensionInput,
  DIMENSION_INPUT_SIZE
} from "../elements/dimensioninput.jsx";
import { PropertiesField } from "../field/index.jsx";

export function SingleDimensionProperty({
  label,
  value,
  onChange = () => {},
  units,
  onReset,
  modified,
  size = DIMENSION_INPUT_SIZE.NORMAL,
  inheritedFrom,
  showReset,
  showInherit,
  isDisabled,
  isInline,
  getPanelContainer
}) {
  return (
    <PropertiesField
      inheritedFrom={inheritedFrom}
      label={label}
      onReset={onReset}
      modified={modified}
      showReset={showReset}
      showInherit={showInherit}
      isInline={isInline}
      getPanelContainer={getPanelContainer}
    >
      <DimensionInput
        value={value}
        onChange={onChange}
        units={units}
        size={size}
        isDisabled={isDisabled}
      />
    </PropertiesField>
  );
}

SingleDimensionProperty.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  onReset: PropTypes.func,
  units: PropTypes.arrayOf(PropTypes.string),
  modified: PropTypes.bool,
  size: PropTypes.oneOf(Object.values(DIMENSION_INPUT_SIZE)),
  inheritedFrom: PropTypes.string,
  showInherit: PropTypes.bool,
  showReset: PropTypes.bool,
  isInline: PropTypes.bool,
  isDisabled: PropTypes.bool,
  getPanelContainer: PropTypes.func
};
